import { computed } from "vue";
import { randomColorWordCloud } from "../utils/word-cloud";
export default {
  name: "KilaKilaWordCloudCard",
  emits: ["wordClicked"],
  props: {
    words: {
      type: Array,
      require: true
    },
    baseUrl: {
      type: String,
      require: true
    }
  },
  setup: function setup(props) {
    var clouds = computed(function () {
      return randomColorWordCloud(props.words);
    });
    return {
      clouds: clouds
    };
  }
};